/**
 * AI renders of a floor plan: a realistic picture of the room as planned,
 * drawn by the configured image model from a snapshot of the 3D view (the
 * layout it must keep), reference photos (the look) and the producer's words.
 *
 * A render is a job, because drawing takes longer than an API request may:
 * `POST` records it and hands it to a worker, and the page asks after it until
 * it is `DONE` or `FAILED`. The pictures are entity attachments on the plan
 * (`documentType: 'AI_RENDER'`), so they are files like any other.
 */
export const AI_RENDER_STATUSES = ['QUEUED', 'RUNNING', 'DONE', 'FAILED'];
/** How many pictures one render may ask for. */
export const MAX_RENDER_IMAGES = 4;
/** How many reference photos one render may carry. */
export const MAX_RENDER_REFERENCES = 4;
/**
 * The largest reference photo a render reads. Bedrock takes a picture of about
 * 3.75 MB; a bigger one is refused when it is chosen, never skipped quietly.
 */
export const MAX_RENDER_REFERENCE_BYTES = 3_700_000;
/** The longest direction a producer may write. */
export const MAX_RENDER_PROMPT_LENGTH = 1000;
/** `documentType` of the pictures a render produces, on the plan's attachments. */
export const AI_RENDER_DOCUMENT_TYPE = 'AI_RENDER';
/** `documentType` of a reference photo uploaded for renders, kept for reuse. */
export const AI_RENDER_REFERENCE_DOCUMENT_TYPE = 'AI_RENDER_REFERENCE';
/** The entity type a plan's render files are attached under. */
export const FLOOR_PLAN_ATTACHMENT_ENTITY = 'FLOOR_PLAN';
/** App settings the feature reads. */
export const AI_RENDER_ENABLED_SETTING = 'ai_render_enabled';
export const AI_RENDER_MONTHLY_LIMIT_SETTING = 'ai_render_monthly_limit';
/** Renders an event may start in a calendar month when the setting is unset. */
export const DEFAULT_AI_RENDER_MONTHLY_LIMIT = 40;
//# sourceMappingURL=ai-render.js.map